import * as React from 'react'
import { useAutoAnimate } from '@formkit/auto-animate/react'
import classNames from 'classnames'
import { TotalEmissionsReportSettings } from '@/hooks'
import { InfoText } from '@/components/atoms/InfoText/InfoText'
import { useTranslation } from 'react-i18next'
import { TotalEmissionsView } from './TotalEmissionsView'
import { ViewAsToggle } from '@/components/molecules'
import { SustainabilityFiltersValues } from '@/utils/constants'
import { useSustainabilityFiltersGetParams } from '../../hooks/useSustainabilityFiltersGetParams'
import { ViewType } from '@/stores/useViewAsToggle/useViewAsToggle'

type TotalEmissionsReportProps = {
    reportSettings: TotalEmissionsReportSettings
    isOpen?: boolean
    calculationMethodOffset?: number
    filters: SustainabilityFiltersValues
    view: ViewType
    setView: (view: ViewType) => void
}

export const TotalEmissionsReport: React.FC<TotalEmissionsReportProps> = (
    props
) => {
    const {
        reportSettings,
        isOpen = false,
        calculationMethodOffset,
        filters,
        view,
        setView,
    } = props

    const getParams = useSustainabilityFiltersGetParams(filters, reportSettings)
    const [animationParent] = useAutoAnimate()
    const { t } = useTranslation('translations')

    const toggleContainerClassName = classNames('flex items-center gap-4')

    return (
        <div
            className="grid w-full grid-cols-[100%] grid-rows-[auto_1fr] gap-6 p-6"
            ref={animationParent}
        >
            <div className="flex items-center justify-between">
                <div className="flex items-center">
                    <div
                        className={classNames({
                            'transition-all duration-300 ease-out': isOpen,
                        })}
                        style={{
                            width: `${String(calculationMethodOffset)}px`,
                        }}
                    />
                    <InfoText
                        text={t('common.calculation_info.calendar_month.label')}
                        icon="info"
                        tooltipContent={t(
                            'common.calculation_info.calendar_month.tooltip'
                        )}
                    />
                </div>

                <div className={toggleContainerClassName}>
                    <ViewAsToggle
                        activeView={view}
                        onViewChange={setView}
                        data-testid="view-toggle-button"
                        icons={{
                            chart: 'donut_large',
                            table: 'table_chart',
                        }}
                    />
                </div>
            </div>

            <TotalEmissionsView
                activeView={view}
                reportSettings={reportSettings}
                filters={getParams}
            />
        </div>
    )
}
